module.exports = __webpack_public_path__ + "img/suitelogo.c8ac42fc.png";